import React, { useRef, useState } from 'react';
import { Pause, Play } from 'lucide-react';

const timeLabel = seconds => `${Math.floor(seconds / 60)}:${String(Math.floor(seconds % 60)).padStart(2, '0')}`;

export default function WhatsAppAudioPlayer({ url, onLoad }) {
  const audio = useRef(null);
  const [playing, setPlaying] = useState(false);
  const [duration, setDuration] = useState(0);
  const [position, setPosition] = useState(0);
  const [error, setError] = useState('');
  const updateDuration = () => {
    const value = audio.current.duration;
    setDuration(Number.isFinite(value) ? value : 0);
  };
  const toggle = async () => {
    if (!audio.current.paused) { audio.current.pause(); return; }
    setError('');
    try { await audio.current.play(); }
    catch { setError('Could not play this voice note. Try again.'); }
  };

  return <div className="w-60 max-w-full py-1">
    <audio ref={audio} src={url} preload="metadata" aria-label="Voice note"
      onLoadedMetadata={() => { updateDuration(); onLoad?.(); }} onDurationChange={updateDuration}
      onTimeUpdate={() => setPosition(audio.current.currentTime)}
      onPlay={() => setPlaying(true)} onPause={() => setPlaying(false)} onEnded={() => setPlaying(false)}
      onError={() => { setPlaying(false); setError('This voice note could not be played.'); }} />
    <div className="flex items-center gap-3">
      <button type="button" onClick={toggle} aria-label={playing ? 'Pause voice note' : 'Play voice note'}
        className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-primary-100 text-primary-700 hover:bg-primary-200">
        {playing ? <Pause aria-hidden="true" className="h-5 w-5" /> : <Play aria-hidden="true" className="ml-0.5 h-5 w-5" />}
      </button>
      <div className="min-w-0 flex-1">
        <input type="range" min="0" max={duration || 1} step="0.1" value={Math.min(position, duration || 0)} disabled={!duration}
          aria-label="Voice note position" aria-valuetext={`${timeLabel(position)} of ${timeLabel(duration)}`}
          onChange={event => { const value = Number(event.target.value); audio.current.currentTime = value; setPosition(value); }}
          className="block h-11 w-full cursor-pointer accent-primary-600 disabled:opacity-50" />
        <div aria-hidden="true" className="-mt-1 flex justify-between text-[10px] tabular-nums text-gray-500">
          <span>{timeLabel(position)}</span><span>{duration ? timeLabel(duration) : '—'}</span>
        </div>
      </div>
    </div>
    {error && <p role="alert" className="mt-1 text-xs text-red-800">{error}</p>}
  </div>;
}
